import React from 'react';
import styled from 'styled-components';

const StyledAboutSection = styled.section`
  .mobile-heading {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--lightest-slate);

    @media (min-width: 1024px) {
      display: none;
    }
  }

  p {
    margin: 0 0 16px;
    color: var(--slate);
  }
`;

const About = () => (
  <StyledAboutSection id="about" tabIndex="-1">
    <h2 className="mobile-heading">About</h2>
    <div>
      <p>
        Hi there! I’m Satender, a Computer Engineering graduate from{' '}
        <a href="https://www.svnit.ac.in/">NIT Surat</a>. I like building reliable user interfaces
        and, more recently, AI systems that people actually use.
      </p>
      <p>
        Currently I’m a Senior Software Engineer at{' '}
        <a href="https://www.netcracker.com/">Netcracker</a>, where I ship production frontend
        experiences for large-scale platforms. Previously I did the same at{' '}
        <a href="https://www.linkedin.com/company/bluejeans-by-verizon/about/">
          BlueJeans by Verizon
        </a>{' '}
        and <a href="https://www.amdocs.com/">Amdocs</a> — CRM UIs, React systems, and product
        delivery with design, product, and engineering partners.
      </p>
      <p>
        These days I’m focused on generative AI: transformers, RAG, vector search, and agentic
        workflows. I also built <a href="https://revcopilot.in">RevCopilot</a>, a public AI product
        that has seen a strong response from users — the kind of feedback that pushed me deeper into
        streaming, retrieval, evaluation, and safe tool use.
      </p>
    </div>
  </StyledAboutSection>
);

export default About;
